package com.patronat.top.ui.molecules.filters

data class FilterOption(
    val id: String,       // Наприклад: "ACTIVE", "BLOCKED" або "1", "2"
    val label: String     // Наприклад: "Активний", "Заблокований"
)